import api from './api';
import { DashboardSummary, ApiResponse } from '../types';

/**
 * Suppress global error toasts on background dashboard polls — failures are
 * already surfaced in Redux state (loading / error). Without this every
 * slow-responding poll on browser refresh would fire its own popup, which
 * is what the user reported.
 */
const noToast = { headers: { _suppressToast: 'true' as const } };

export const dashboardService = {
  async getSummary(alertDays?: number) {
    const params = alertDays ? { alertDays } : {};
    return api.get<ApiResponse<DashboardSummary>>('/dashboard/summary', { params, ...noToast });
  },

  async getPortfolioGrowthData(period: string) {
    return api.get(`/dashboard/charts/portfolio-growth`, { params: { period }, ...noToast });
  },

  async getMarginUtilizationData(period: string) {
    return api.get(`/dashboard/charts/margin-utilization`, { params: { period }, ...noToast });
  },

  async getPnLTrendData(period: string) {
    return api.get(`/dashboard/charts/pnl-trend`, { params: { period }, ...noToast });
  }
};
